export const starterKitBuyNow = `https://us.ecoflow.com/products/delta-pro-portable-power-station`;

export const starterKitBuyNow1 = `https://us.ecoflow.com/products/delta-2-max-portable-power-station?variant=40539815673929`;

export const advencedKitBuyNow = `https://us.ecoflow.com/products/delta-pro-double-voltage-hub`;

export const smartContralKitBuyNow = `https://us.ecoflow.com/products/ecoflow-delta-pro-smart-home-panel`;
